var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "toggle@1x-a",
          d:
            "M15.8571428,9 C14.2002885,9 12.8571428,10.3431458 12.8571428,12 C12.8571428,13.6568542 14.2002885,15 15.8571428,15 C17.513997,15 18.8571428,13.6568542 18.8571428,12 C18.8571428,10.3431458 17.513997,9 15.8571428,9 Z M15.8571428,13.2857143 C15.1470624,13.2857143 14.5714285,12.7100804 14.5714285,12 C14.5714285,11.2899196 15.1470624,10.7142857 15.8571428,10.7142857 C16.5672232,10.7142857 17.1428571,11.2899196 17.1428571,12 C17.1428571,12.7100804 16.5672232,13.2857143 15.8571428,13.2857143 Z M15.8571428,6 L9,6 C5.68629145,6 3,8.68629154 3,12 C3,15.3137085 5.68629145,18 9,18 L15.8571428,18 C19.1708512,18 21.8571426,15.3137084 21.8571426,12 C21.8571426,8.68629156 19.1708512,6 15.8571428,6 Z M15.8571428,16.2857143 L8.99999991,16.2857143 C6.63306527,16.2857143 4.71428562,14.3669346 4.71428562,12 C4.71428562,9.63306536 6.63306527,7.71428571 8.99999991,7.71428571 L15.8571428,7.71428571 C18.2240774,7.71428571 20.1428571,9.63306536 20.1428571,12 C20.1428571,14.3669346 18.2240774,16.2857143 15.8571428,16.2857143 Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "fill-rule": "nonzero",
          "xlink:href": "#toggle@1x-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }